import {
  CLASSIC_LENS_TAB,
  LOOKS_TAB,
  MAKEUP_TAB,
  FRESH_LENS_TAB,
  All_LENS_TAB,
  showFreshTab,
  showLooksTab,
  showMakeupTab,
  showClassicTab,
  showAllLensesTab
} from 'Root/constants';
// src/constants/index.js

const tabs = [
  {
    id: 'tabs.fresh_lenses',
    title: FRESH_LENS_TAB,
    className: 'tabs--color__fresh',
    data: FRESH_LENS_TAB,
    show: showFreshTab,
  },
  {
    id: 'tabs.classic_lenses',
    title: CLASSIC_LENS_TAB,
    className: 'tabs--color__classic',
    data: CLASSIC_LENS_TAB,
    show: showClassicTab,
  },
  {
    id: 'tabs.allLenses',
    title: All_LENS_TAB,
    className: 'tabs--color__allLenses',
    data: All_LENS_TAB,
    show: showAllLensesTab,
  },
  {
    id: 'tabs.looks',
    title: LOOKS_TAB,
    className: 'tabs--color__looks',
    data: LOOKS_TAB,
    show: showLooksTab,
  },
  {
    id: 'tabs.makeup',
    title: MAKEUP_TAB,
    className: 'tabs--color__makeup',
    data: MAKEUP_TAB,
    show: showMakeupTab,
  },
].filter((item) => item.show);

export { tabs };
